import { render } from "./component-submit-date.vue?vue&type=template&id=4b6d8226"
import script from "./component-submit-date.vue?vue&type=script&setup=true&lang=js"
export * from "./component-submit-date.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-submit-date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b6d8226"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b6d8226', __exports__)) {
    api.reload('4b6d8226', __exports__)
  }
  
  module.hot.accept("./component-submit-date.vue?vue&type=template&id=4b6d8226", () => {
    api.rerender('4b6d8226', render)
  })

}


export default __exports__